export const YOUTUBECONSENT = "gatsby-gdpr-youtube"
export const INSTAGRAMCONSENT = "gatsby-gdpr-instagram"
export const GATSBY_GA_TRACKING = process.env.GATSBY_GA_TRACKING
export const GA_COOKIE = "gdpr-google-analytics";